'use client';

import { PropsWithChildren } from 'react';
import { useAsync } from 'react-use';

import { initAuth } from '../store';

export const AuthProvider = ({
  children,
  isAuthCompassion = false,
}: PropsWithChildren & { isAuthCompassion?: boolean }) => {
  /**
   * Initialize state once mounted.
   * TODO: look into if this would be a good candidate for useTransition
   */
  useAsync(async () => {
    await initAuth(isAuthCompassion);
  }, []);

  // Removing the fragment causes a break
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
